import { DiscussionContext, DiscussionType } from "@cnx/common";
import ChatTitle from "./ChatTitle";
import ChatHeader from "./ChatHeader";

type ChatHeaderPanelProps = {
  discussionType: DiscussionType;
  discussionId?: string;
  phone?: string;
  avatarId?: string | null;
  participantName?: string;
  context?: string | null;
  stopActivityKind?: string | null;
  onGoBack?: () => void;
  onClose?: () => void;
  onViewParticipants?: () => void;
  title?: string;
  discussionContext?: DiscussionContext;
  typingLabel?: string | null;
  className?: string;
};

const ChatHeaderPanel = ({
  discussionType,
  discussionId,
  phone,
  avatarId,
  participantName,
  context,
  stopActivityKind,
  onGoBack,
  onClose,
  onViewParticipants,
  title,
  discussionContext,
  typingLabel,
  className,
}: ChatHeaderPanelProps) => (
  <ChatHeader
    discussionId={discussionId}
    discussionType={discussionType}
    phone={phone}
    avatarId={avatarId}
    participantName={participantName}
    context={context}
    stopActivityKind={stopActivityKind}
    onGoBack={onGoBack}
    onClose={onClose}
    onViewParticipants={onViewParticipants}
    typingLabel={typingLabel}
    className={className}
  >
    <ChatTitle title={title} discussionContext={discussionContext} />
  </ChatHeader>
);

export default ChatHeaderPanel;
